import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDown, CheckCircle } from 'lucide-react';
const faqs = [{
  question: 'My dog is too old to learn.',
  answer: "Dogs are capable of neuroplasticity at any age. This protocol works for seniors just as well as puppies. Age is not a barrier to behavioral change—it's all about the right approach."
}, {
  question: 'I live in a small apartment.',
  answer: 'Perfect. Bonus #2 (Apartment Silence Blueprint) is specifically designed for high-density living and neighbor management. Small spaces can actually make the protocol easier to implement.'
}, {
  question: 'Is there a guarantee?',
  answer: "Yes. 60-Day Money Back Guarantee. If your dog isn't calmer, you don't pay. Period. Try the entire protocol risk-free, and if you're not satisfied, we'll refund every penny."
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="bg-slate-50 py-16 px-4" data-id="element-19">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-20">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 text-center mb-12" data-id="element-21">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200" data-id="element-23">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors" data-id="element-24">
                <span className="font-semibold text-lg text-slate-900 pr-4" data-id="element-25">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-slate-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-26" />
              </button>

              <motion.div initial={false} animate={{
            height: openIndex === index ? 'auto' : 0,
            opacity: openIndex === index ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-27">
                <div className="px-6 pb-5 flex items-start gap-3" data-id="element-28">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-29" />
                  <p className="text-slate-700 leading-relaxed" data-id="element-30">{faq.answer}</p>
                </div>
              </motion.div>
            </div>)}
        </div>
      </motion.div>
    </section>;
}